import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = () => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  return isAuthenticated && user ? (
    <Outlet />
  ) : (
    <Navigate
      to="/login"
      state={{ returnTo: location.pathname + location.search }}
      replace
    />
  );
};

export default ProtectedRoute;
